import {
  SetCategories,
  SetCurrentFields,
  SetCurrentPromptCard,
  SetDisplayPromptsInNewTab,
  SetPrompts,
  SetPromptsDefaultState,
  SetSelectedCategories,
} from '~/constants/actions';
import {
  GetCategories,
  GetCurrentFields,
  GetCurrentPromptCard,
  GetDisplayPromptsInNewTab,
  GetPrompts,
  GetSelectedCategories,
} from '~/constants/getters';

const defaultState = () => {
  return {
    currentPromptCard: null,
    currentFields: [],
    displayPromptsInNewTab: false,
    prompts: [],
    categories: [],
    selectedCategories: [],
  };
};

const state = defaultState();

const mutations = {
  [SetCurrentFields](state, data) {
    state.currentFields = data;
  },
  [SetPromptsDefaultState](state) {
    Object.assign(state, {
      currentPromptCard: null,
      displayPromptsInNewTab: false,
    });
  },
  [SetCurrentPromptCard](state, data) {
    state.currentPromptCard = data;
  },
  [SetDisplayPromptsInNewTab](state, data) {
    state.displayPromptsInNewTab = data;
  },
  [SetPrompts](state, data) {
    state.prompts = data;
  },
  [SetCategories](state, data) {
    state.categories = data;
  },
  [SetSelectedCategories](state, data) {
    state.selectedCategories = data;
  },
};

const getters = {
  [GetCurrentFields](state) {
    return state.currentFields;
  },
  [GetCurrentPromptCard](state) {
    return state.currentPromptCard;
  },
  [GetDisplayPromptsInNewTab](state) {
    return state.displayPromptsInNewTab;
  },
  [GetPrompts](state) {
    return state.prompts;
  },
  [GetCategories](state) {
    return state.categories;
  },
  [GetSelectedCategories](state) {
    return state.selectedCategories;
  },
};

const actions = {
  [SetCurrentFields]: ({ commit }, data) => {
    commit(SetCurrentFields, data);
  },
  [SetCurrentPromptCard]: ({ commit }, data) => {
    commit(SetCurrentPromptCard, data);
  },
  [SetPromptsDefaultState]: ({ commit }) => {
    commit(SetPromptsDefaultState);
  },
  [SetDisplayPromptsInNewTab]: ({ commit }, data) => {
    commit(SetDisplayPromptsInNewTab, data);
  },
  [SetPrompts]: ({ commit }, data) => {
    commit(SetPrompts, data);
  },
  [SetCategories]: ({ commit }, data) => {
    commit(SetCategories, data);
  },
  [SetSelectedCategories]: ({ commit }, data) => {
    commit(SetSelectedCategories, data);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
